import { ReactElement } from 'react'

import { Flex } from 'components/core'
import { AUTOMATIONS } from 'const/automations'
import { AutomationCapabilityId } from 'types'

import CapabilityIcon from '../AutomationCapabilityIcon'

interface Props {
    capabilityId: AutomationCapabilityId
}

export default function AutomationCapabilityElement({
    capabilityId,
}: Props): ReactElement {
    return (
        <Flex>
            <CapabilityIcon capabilityId={capabilityId} />
            {AUTOMATIONS[capabilityId].name}
        </Flex>
    )
}
